import { render, staticRenderFns } from "./GenCertificadoDetail.vue?vue&type=template&id=c9479a0c"
import script from "./GenCertificadoDetail.vue?vue&type=script&lang=js"
export * from "./GenCertificadoDetail.vue?vue&type=script&lang=js"
import style0 from "./GenCertificadoDetail.vue?vue&type=style&index=0&id=c9479a0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports